import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import CanvasEnabled from "./canvas/CanvasEnabled"
import CanvasDisable from "./canvas/CanvasDisable"

/* Protopia Ecosystem component */
export interface ICanvasScalarProps extends ICompositeWidgetProps {
   
}
const CanvasScalar = (props: ICanvasScalarProps): JSX.Element => {
    return <>
        <Scalar  
            value={ props.value }
            editable={props.editable }
            field={props.field}
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.VERTICAL }
            enabledForm={ <CanvasEnabled {...props} /> }  
            desabledForm={ <CanvasDisable {...props} /> }  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}  
            onChange={props.onChange}
        />
    </>
}
export default CanvasScalar